import { Branch } from "../../agatextscreens/accounting/branch";

export class User {
    id: string;
    name: string;
    first_name: string;
    last_name: string;
    cpn_code: string;
    role: string;
    branch_id: number;
    status: string;
    right_level: string;
    printer_id: number;
    csv_separator: string;

    language: number;

    branch_list: Branch[] = [];
    module_roles: {id: string, name: string}[] = [];
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/classes/user.ts